import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash, PaperPlaneTilt } from "@phosphor-icons/react";

export default function Users() {
  const [items, setItems] = useState([]);
  const [roles, setRoles] = useState([]);
  const [mode, setMode] = useState("invite"); // "invite" | "manual"
  const [form, setForm] = useState({ email: "", name: "", password: "", role: "musyrif" });

  const load = async () => {
    try { const { data } = await api.get("/auth/users"); setItems(data); }
    catch (e) { toast.error(e.response?.data?.detail || e.message); }
  };
  useEffect(() => { load(); api.get("/auth/roles").then((r) => setRoles(r.data)); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (mode === "invite") {
        const { data } = await api.post("/auth/invite", { email: form.email, name: form.name, role: form.role });
        if (data.email_sent) toast.success("Undangan aktivasi terkirim ke email");
        else toast.warning(`User dibuat, tapi email GAGAL dikirim: ${data.error || "unknown"}`);
      } else {
        await api.post("/auth/users", form);
        toast.success("User dibuat dengan password langsung");
      }
      setForm({ email: "", name: "", password: "", role: "musyrif" });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
  };
  const del = async (id) => { if (!window.confirm("Hapus user?")) return; await api.delete(`/auth/users/${id}`); load(); };

  return (
    <div className="space-y-5">
      <div>
        <div className="text-xs uppercase tracking-widest text-slate-400">Administrasi</div>
        <h1 className="font-display text-3xl font-bold text-[#064E3B]">Pengguna Sistem</h1>
      </div>

      <div className="imsyaf-card p-2 flex gap-1 flex-wrap">
        <button onClick={() => setMode("invite")} data-testid="users-mode-invite"
          className={`px-4 py-2 rounded-md text-sm font-medium ${mode === "invite" ? "bg-[#14532d] text-white" : "text-slate-600 hover:bg-slate-100"}`}>
          <PaperPlaneTilt size={14} className="inline -mt-0.5 mr-1"/> Undang via Email
        </button>
        <button onClick={() => setMode("manual")} data-testid="users-mode-manual"
          className={`px-4 py-2 rounded-md text-sm font-medium ${mode === "manual" ? "bg-[#14532d] text-white" : "text-slate-600 hover:bg-slate-100"}`}>
          Set Password Langsung
        </button>
      </div>

      <form onSubmit={submit} className="imsyaf-card p-5 grid md:grid-cols-5 gap-3">
        <div><label className="text-xs">Nama *</label><input required className="imsyaf-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="user-name" /></div>
        <div><label className="text-xs">Email *</label><input required type="email" className="imsyaf-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="user-email" /></div>
        {mode === "manual" && (
          <div><label className="text-xs">Password *</label><input required type="password" minLength={6} className="imsyaf-input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="user-password" /></div>
        )}
        <div><label className="text-xs">Role</label>
          <select className="imsyaf-input" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} data-testid="user-role">
            {roles.map((r) => <option key={r.code} value={r.code}>{r.label}</option>)}
          </select></div>
        <div className="flex items-end">
          <button className="imsyaf-btn-primary w-full" data-testid="user-save-btn">
            {mode === "invite" ? <><PaperPlaneTilt size={16}/> Kirim Undangan</> : <><Plus size={16}/> Tambah</>}
          </button>
        </div>
        {mode === "invite" && (
          <div className="md:col-span-5 text-xs text-slate-500 -mt-1">
            User akan menerima email undangan dengan link untuk membuat password sendiri (berlaku 7 hari).
          </div>
        )}
      </form>

      <div className="imsyaf-card overflow-hidden">
        <table className="w-full text-sm zebra">
          <thead className="bg-slate-50"><tr>
            <th className="text-left px-4 py-2">Nama</th><th className="text-left px-4 py-2">Email</th>
            <th className="text-left px-4 py-2">Role</th><th className="text-left px-4 py-2">Status</th><th></th>
          </tr></thead>
          <tbody>{items.map((u) => (
            <tr key={u.id} className="border-t border-slate-100">
              <td className="px-4 py-2 font-medium">{u.name}</td><td className="px-4 py-2">{u.email}</td>
              <td className="px-4 py-2"><span className="imsyaf-badge bg-green-50 text-green-800">{u.role}</span></td>
              <td className="px-4 py-2">{u.active === false ? <span className="imsyaf-badge bg-amber-100 text-amber-700">Menunggu Aktivasi</span> : <span className="imsyaf-badge bg-green-100 text-green-800">Aktif</span>}</td>
              <td className="px-4 py-2 text-right"><button className="imsyaf-btn-ghost text-red-600" onClick={() => del(u.id)}><Trash size={14}/></button></td>
            </tr>
          ))}
          {items.length === 0 && <tr><td colSpan={5} className="text-center py-8 text-slate-400">Belum ada user.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
